/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDetailModel } from '../../models/article-detail-model';

export interface ArticlePublisherIdIdHtmlArticleLanguageIdGet$Plain$Params {
  publisherId: string;
  id: string;
  languageId: string;
}

export function articlePublisherIdIdHtmlArticleLanguageIdGet$Plain(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdHtmlArticleLanguageIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleDetailModel>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdHtmlArticleLanguageIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
    rb.path('languageId', params.languageId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<ArticleDetailModel>;
    })
  );
}

articlePublisherIdIdHtmlArticleLanguageIdGet$Plain.PATH = '/Article/{publisherId}/{id}/HtmlArticle/{languageId}';
